import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import moment from 'moment';
import DatePicker from "react-datepicker";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { HRM_API_BASE_URL_2, SCHEDULE_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapIcon from '../../../services/TapIcon';
import Loader from '../../../components/ui/Loader/Loader';
import * as actions from "../../../store/actions/index";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import EmployeeShiftLinkingModal from '../includes/EmployeeShiftLinkingModal';
import AttendanceMultipleEmployeeModal from './includes/AttendanceMultipleEmployeeModal';
import DateService from '../../../services/DateService';
import Status from '../../../components/ui/Status';
import EmpAttendanceDetailJsx from './includes/EmpAttendanceDetailJsx';
import EmployeeSearchModal from '../employee/EmployeeSearchModal';
import AttendenceUploadModal from '../attendence1/AttendenceUploadModal';
import AttendenceEditDeleteModal from './AttendenceEditDeleteModal';
import AttendenceSummary from '../attendence1/AttendenceSummary';
import WorkLogModal from '../attendence1/WorkLogModal';
import DownloadFile from '../../../services/DownloadFile';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';


const DailyAttendance                   =   forwardRef((props, ref) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let transactionDate = searchParams.get('transaction_date');
    
    const today                             =   new Date();
    const searchEmployeeModalRef            =   useRef(null);   
    const bulkAttendenceModalRef            =   useRef(null);
    let initListData                        =   {
        loading                                 :   false,
        items                                   :   [],
        sites                                   :   [],
        meta                                    :   null,
        page                                    :   1,
        per_page                                :   50
    };
    let initFormData                        =   {
        submitting                              :   false,
        transaction_date                        :   transactionDate ? new Date(transactionDate) : new Date()
    };
    let initAttendanceSummary              =   {
        display                                 :   false
    }
    const criteriaRef                       =   useRef()
    const empShiftLinkingModalRef           =   useRef(null);
    const attendanceMultipleEmployeeModalRef=   useRef(null);
    const attendenceDeleteModalRef          =   useRef(null)
    const workLogModalRef           =   useRef(null);

    const dispatch                          =   useDispatch();
    const access_token                      =   useSelector(state => state.auth.access_token);

     const [formSearchedElems, setFormSearchedElems]     =   useState([]);
    const [submittedSearchForm, setSubmittedSearchForm] =   useState({});
    const [itemData, setItemData]           =   useState({...initListData});
    const [formData, setFormData]           =   useState({...initFormData});
    const [attendanceSummary, setAttendanceSummary]=  useState({...initAttendanceSummary});
    const [criteriaHeight ,setCriteriaHeight]                       = useState(0)      
    const [downloadLoading ,setDownloadLoading]                     = useState(false)   
    const [selectedAttendanceDetail, setSelectedAttendanceDetail] = useState(null);
    const[queryDate, setQueryDate]  = useState(transactionDate)
    

     let itemFormDataUrl                     =   HRM_API_BASE_URL_2 + "/daily_attendance/form_data";
    let listUrl                             =   HRM_API_BASE_URL_2 + "/daily_attendance/employee";
    let downloadUrl                         =   HRM_API_BASE_URL_2 + "/attendance/daily_download";

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;

            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };
    useEffect(() => {
        updateCriteriaHeight(); 
        loadListData();
    }, [submittedSearchForm, formData.transaction_date]);

    const handleStatusClick = (data) => {
        setSelectedAttendanceDetail({
            date: moment(formData.transaction_date).format("YYYY-MM-DD"),
            employeeId: data?.employee?.enc_id,
            employeeData : data?.employee,
            attendence : data?.attendances
        });
    };

    const closeDetailView = () => {
        refreshDataEvent()
        setSelectedAttendanceDetail(null);
    };
  const loadListData                      =   (page = 1, date = null)  =>  {

        let params          =   {
                                    ...submittedSearchForm,
                                    page : page,
                                    ...formData, 
                                    transaction_date : queryDate ? queryDate : moment(date ? date : formData.transaction_date).format("YYYY-MM-DD")
                                };
        // if(params?.search_attendance_status?.includes(3) && params?.search_attendance_status?.length === 1 && moment(today).format("YYYY-MM-DD") != params.transaction_date) {
        //     setItemData(initListData);
            setItemData(pd => ({...pd, loading : true, page : page }));
            HttpAPICall.withAthorization('GET', listUrl, access_token, params, {}, (response) => {
               let respData                =   response.data.employees;
                let meta                    =   {
                    from                        :   respData.from,
                    to                          :   respData.to,
                    total                       :   respData.total,
                    last_page                   :   respData.last_page,
                    per_page                    :   respData.per_page,
                    current_page                :   respData.current_page
                };
                setItemData(pd => ({...pd, items : respData.data, meta : meta, sites : response.data.sites }));
            }).then(() => {
                setItemData(pd => ({...pd, loading : false}));
            });
    }

     const refreshDataEvent                  =   ()  =>  {
        loadListData(itemData.page);
    }

    const checkAllItem                      =   (event) => {
        const employeeCollections = document.getElementsByClassName('employee_id_checkbox');
        for (let i = 0; i < employeeCollections.length; i++) {
            employeeCollections[i].checked = event.target.checked;
        }
    }

    const linkEmployeeToShift               =   (employee_id) => {
        if (empShiftLinkingModalRef.current) {
            empShiftLinkingModalRef.current.initModalHandler(employee_id);
        }
    }

    const workLogInit = (data , attendance) => {
        workLogModalRef.current.worklogModalInit(data ,attendance);
    }

    const dateChangeHandler                 =   (transaction_date)  =>  {
        if(transaction_date=='prev') {
            transaction_date                =   DateService.subDays(1, formData.transaction_date);
        }
        if(transaction_date=='next') {
            transaction_date                =   DateService.addDays(1, formData.transaction_date);
        }
        setQueryDate(moment(transaction_date).format("YYYY-MM-DD"))
        setFormData(pd => ({...pd, transaction_date }));
    }

    const getSelectedEmployeeIds            =   ()  =>  {
        const employeeCollections               =   document.getElementsByClassName('employee_id_checkbox');
        let employee_ids                        =   [];
        for (let i = 0; i < employeeCollections.length; i++) {
            if(employeeCollections[i].checked) {
                employee_ids.push(employeeCollections[i].value);
            }
        }
        return employee_ids;
    }

    const initAttendanceModal               =   (action)  =>  {
        try {
            let employee_ids                    =   getSelectedEmployeeIds();
            if(employee_ids.length == 0) {
                throw new Error("Please select employee");
            }
            let employees                       =   itemData.items.filter(i => employee_ids.includes(i.employee.enc_id)).map(e => e.employee);
            if (attendanceMultipleEmployeeModalRef.current) {
                attendanceMultipleEmployeeModalRef.current.initModalHandler(employees, action);
            }
        } catch (error) {
            toast.error(error.message, { position: toast.POSITION.TOP_RIGHT});
        }
    }
 


    const initAttendanceDeleteModal = (attendance, employeeName, isEdit = false) => {
        if (attendenceDeleteModalRef.current) {
            attendenceDeleteModalRef.current.initModalHandler(attendance, employeeName, isEdit);
        }
    };
    
  
    
    const initDisplayAttendanceSummary      =   (attendance_id)  =>  {
        // setAttendanceSummary(pd => ({
        //     ...pd,
        //     display                 :   true,
        //     attendance_id           :   attendance_id,
        //     date                    :   DateService.dateTimeFormat(formData.transaction_date, 'DD-MMM-YYYY')
        // }));
    }

    const searchHandle                      =   (element,data)  =>  {
        setFormSearchedElems(element);
        setSubmittedSearchForm(data);
    }

    const employeeSearchClear               =   ()  =>  {
        setSubmittedSearchForm({});
        setFormSearchedElems([]);
         setCriteriaHeight(0)

    };

    const searchModalHandle                 =   () => {
        
        if(searchEmployeeModalRef.current) {
            searchEmployeeModalRef.current.initModalHandler()
        }
    }
    const attendanceModalHandle             =   ()  => {
        if(bulkAttendenceModalRef.current) {
            bulkAttendenceModalRef.current.modalHandle();
        }
    }
   
    const attendanceDownloadHandle = () => {
        setDownloadLoading(pre => !pre);
        const date_range = formData?.transaction_date
            ? moment(formData.transaction_date).format("YYYY-MM-DD")
            : '';
        const params = { type: "daily_attendance", date_range, transaction_date: date_range, ...submittedSearchForm };
        HttpAPICall.withAthorization('GET', downloadUrl, access_token, params, {}, (response) => {
            DownloadFile.file(response.data.file_path,response.data.msg,response.data.navigation,props)
        }).then(() => setDownloadLoading(pre => !pre));
    }
    
    const headerJsx                         =   ()  =>  {
        return <>
            <Helmet><title>Daily Employee Attendance</title></Helmet>
            <div className=" page_title m0 row ">
                <div className='col-sm-12'>
                    <div className='row '>
                        <div className='col-sm-4'>
                            <h3 className='mb-0'>Daily Employee Attendance</h3>
                        </div>
                        <div className='col-sm-4'>
                            <div className="justify-content-center attendence_input mt15">
                                <button className="btn btn-secondary" type="button" disabled={itemData.loading} onClick={() => dateChangeHandler('prev')}><TapIcon.FontAwesomeIcon icon={TapIcon.faArrowLeft} /></button>
                                <div className="add_calender_section mx-1">
                                    <DatePicker
                                        selected={formData.transaction_date}
                                        onChange={date => dateChangeHandler(date)}
                                        dateFormat="dd-MMM-yyyy"
                                        className="form-control form-control-sm"
                                        showMonthDropdown
                                        showYearDropdown
                                        autoComplete="off"
                                        scrollMonthYearDropdown
                                        required={true}
                                        maxDate={new Date()}
                                        disabled={itemData.loading}
                                        placeholderText={`Please Enter Date `}
                                    />
                                    <TapIcon.imageIcon icon={TapIcon.CalenderIcon} className="add_calender-icon" style={{ top: "6px" }} />
                                </div>
                                <button className="btn btn-secondary ml0" type="button" disabled={itemData.loading || ( moment(formData.transaction_date).format("YYYY-MM-DD") >= moment(new Date()).format("YYYY-MM-DD") )} onClick={() => dateChangeHandler('next')}><TapIcon.FontAwesomeIcon icon={TapIcon.faArrowRight} /></button>
                            </div>
                        </div>
                        <div className='col-sm-4'>
                            <div className='text-end d-flex gap-2 align-items-center justify-content-end mt15'>
                                <span className="dropdown">
                                    <button type="button" data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary" disabled={itemData.loading}>Update Attendence</button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" >
                                        <li><Link className="dropdown-item" role="button" onClick={() => initAttendanceModal("checkin")}>Check-In</Link> </li>
                                        <li><Link className="dropdown-item" role="button" onClick={() => initAttendanceModal("checkout")}>Check-Out</Link> </li>
                                       
                                    </ul>
                                </span>
                                <button type="button" className="btn btn-secondary" disabled={itemData.loading} onClick={searchModalHandle}>
                                    <TapIcon.imageIcon icon={TapIcon.SearchIcon} />
                                </button>
                                <button type="button" id='actionHeaderButton' className="btn btn-secondary ml0" data-bs-toggle="dropdown" aria-expanded="false" disabled={itemData.loading}>
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="actionHeaderButton">
                                    <li><button  className="btn-link dropdown-item" role="button" onClick={attendanceModalHandle}>Upload Attendance</button></li>
                                     <li><button  disabled={downloadLoading} className="btn-link dropdown-item" role="button" onClick={attendanceDownloadHandle}>Attendance Download</button></li>
                                </ul>
                                <button type="button" className="btn btn-secondary ml0" disabled={itemData.loading} onClick={refreshDataEvent} >
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className={[itemData.loading ? 'fa-spin' : '' ].join(" ")}   />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
    const attendenceSummaryHeaderJsx = () => {
        return <>
            <Helmet><title>Daily Employee Attendance</title></Helmet>
            <div className=" page_title m0 row ">
                <div className='col-sm-12'>
                    <div className='row '>
                        <div className='col-sm-4'>
                            <h3 className='mb-0'>Daily Employee Attendance</h3>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
  
    const employeeListJsx                   =   ()  =>  {
        return <>
            <div ref={criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
                <DisplaySearchCriteria
                    searchedElems={formSearchedElems}
                    onClearFilter={employeeSearchClear}
                />
            </div>
            <table className="table table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary" style={{
                        top: `${criteriaHeight}px`,
                        position: 'sticky',
                    }}>
                    <tr className='text-center'>
                        <th style={{ width: "4%" }}><input type='checkbox' onChange={checkAllItem} id="all_check_employee" /></th>
                        <th style={{ width: "13%" }}>Employee </th>
                        <th style={{ width: "10%" }}>Attendance Status</th>
                        <th style={{ width: "11%" }}>Check In </th>
                        <th style={{ width: "11%" }}>Check Out</th>
                        <th style={{ width: "10%" }}>Duration</th>
                        <th style={{ width: "10%" }}>WorkLog</th>
                        <th style={{ width: "6%" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {itemData.loading 
                    ?   <tr><td className='text-center' colSpan={8}><Loader /></td></tr>
                    :   (itemData.items && itemData.items.length > 0 
                        ?   itemData.items.map((item,key) => {
                            let site            =   itemData.sites.find( s => s.id ==  item.site_id);
                            let rowspan         =   item.attendances ? (item.attendances.length || 1) : 1; 
                            
                            let Object_rows     =   [];
                            for (let i = 0; i < rowspan; i++) {
                                let attendance  =   item.attendances && item.attendances[i] || null;
                                let tr          =   (<tr key={key+'-'+i}>
                                    {i==0 && <>
                                        <td rowSpan={rowspan} className='text-center va_middle'><input type='checkbox' className="employee_id_checkbox" value={item.employee.enc_id} /></td>
                                        {attendance.id ? <>
                                            <td rowSpan={rowspan}>
                                                <span className="link-primary cursor_pointer" onClick={() => handleStatusClick(item)}>
                                                {item?.employee?.name}
                                                </span>
                                                <br />
                                                {item.employee.employee_code ? item.employee.employee_code : ''}
                                                <br />
                                                {site ? site.site_name : ''}
                                            </td>
                                        </>
                                            : <td rowSpan={rowspan} >{item.employee.name}
                                                <br />
                                                {item.employee.employee_code ? item.employee.employee_code : ''}
                                                <br />
                                                {site ? site.site_name : ''}
                                            </td>}
                                    </>}
                                    {attendance ? (<>
                                        <td className='text-center'>
                                            { attendance.status && <Status color={attendance.status.color_code}>{attendance.status.name}</Status>} 
                                        </td>
                                       <td className='text-center'>
                                            {attendance.check_in_minutes}
                                            {attendance.check_out_date && attendance.check_in_date !== attendance.check_out_date && (
                                                <> <span className="text-muted">
                                                    {attendance.check_in_date ? `(${attendance.check_in_date})` : ""}
                                                </span></>
                                            )}
                                        </td>
                                        <td className='text-center'>
                                            {attendance.check_out_minutes}
                                            {attendance.check_out_date && attendance.check_in_date !== attendance.check_out_date && (
                                                <> <span className="text-muted">
                                                    {attendance.check_out_date ? `(${attendance.check_out_date})` : ""}</span></>
                                            )}
                                        </td>
                                        <td className='text-center'>{attendance?.duration ? attendance?.duration  :" -"}</td>

                                        {attendance.check_in_date && attendance.check_out_date ? <td className='text-center'>
                                            {attendance?.work_log_data && attendance?.work_log_data.length > 0 && (
                                                attendance.work_log_data.map((i, k) => (
                                                    <div key={k}>
                                                        {i.work_log_type?.name} : {i.total_time}
                                                    </div>
                                                ))
                                            )}
                                            <div role="button"
                                                className='link-primary cursor_pointer'
                                                onClick={() => {workLogInit(item , attendance)}}
                                                style={{ "pointerEvents": "all" }}
                                            ><TapIcon.FontAwesomeIcon icon={TapIcon.faPlus} style={{ width: "7px" }} /></div>
                                        </td> : <td className='text-center'>-</td>}

                                </>) : <td colSpan={3}></td>}
                                 <td className='text-center'>
                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn"><TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} />
                                    </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <button onClick={() => { linkEmployeeToShift(item.employee.enc_id); }} className="btn-link dropdown-item" role="button">{item.shift ? 'Change With' : 'Link With'} shift</button>
                                            </li>
                                            <li>
                                                <button className="btn-link dropdown-item" role="button" disabled={!attendance?.check_in_minutes} onClick={() => initAttendanceDeleteModal(attendance, item.employee.display_full_name, true)}>Edit</button>
                                            </li>
                                            <li>
                                                <button className="btn-link dropdown-item" role="button" disabled={!attendance?.check_in_minutes} onClick={() => initAttendanceDeleteModal(attendance,item.employee.display_full_name ,false)}>Delete</button>
                                            </li>
                                        </ul>
                                </td>
                                </tr>);
                                Object_rows.push(tr);
                            }
                            return <>{Object_rows}</>
                        })
                        :   <tr><td className='text-center' colSpan={8}>No Record</td></tr>
                        )
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={itemData.meta} onPageChange={(e) => loadListData(e.selected + 1)} />
            {/* {JSON.stringify(itemData)} */}
        </>
    }

    return <ApplicationLayout>
        {selectedAttendanceDetail ? (
            <>
                {attendenceSummaryHeaderJsx()}
                            <AttendenceSummary
                                attendenceData={selectedAttendanceDetail}
                                onClose={closeDetailView}
                                onAttendanceRefresh={refreshDataEvent}
                            />

            </>

        ) : (<>
            {attendanceSummary.display
                ? <EmpAttendanceDetailJsx attendanceData={attendanceSummary} onClose={() => setAttendanceSummary(pd => ({ ...pd, ...initAttendanceSummary }))} />
                : <>
                    {headerJsx()}
                    <div className="container-fluid pl5">
                        <div className='page_containt row'>
                            <div className='pageTbl col-12'>{employeeListJsx()}</div>
                        </div>
                    </div>
                </>
            }
            <EmployeeShiftLinkingModal ref={empShiftLinkingModalRef} afterSucess={refreshDataEvent} />
            <EmployeeSearchModal ref={searchEmployeeModalRef} searchHandle={(element,searchData) => searchHandle(element, searchData)} listingLoading={itemData.loading} formSearchedElems={formSearchedElems} transaction_date ={formData.transaction_date} />
            <AttendanceMultipleEmployeeModal ref={attendanceMultipleEmployeeModalRef} afterSucess={refreshDataEvent} transaction_date={formData.transaction_date} />
             <AttendenceUploadModal ref={bulkAttendenceModalRef} loadListingTblData={loadListData} submittedSearchForm={submittedSearchForm}/>
            <AttendenceEditDeleteModal ref={attendenceDeleteModalRef}  afterSucess={refreshDataEvent} transaction_date={formData.transaction_date} isReadOnly={true}/>
            <WorkLogModal ref={workLogModalRef} afterSucess={refreshDataEvent}/>
        </>
        )}

    </ApplicationLayout>

});

export default DailyAttendance;
